// extracted by mini-css-extract-plugin
module.exports = {"mainReviewsWrapper":"rp-z"};